interface FooterProps {
  variant?: 'default' | 'dashboard'
}

function Footer({ variant = 'default' }: FooterProps) {
  if (variant === 'dashboard') {
    return (
      <footer className="bg-white border-t border-gray-200 mt-8">
        <div className="w-full px-8 py-4">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-sm text-gray-500">
              &copy; {new Date().getFullYear()} Acme Corp. Secured by Yubico&reg; YubiKey&reg;. All rights reserved.
            </p>
            <div className="flex items-center gap-6 text-sm text-gray-500">
              <a href="#" className="hover:text-yubico-green-400 transition-colors">Privacy Policy</a>
              <a href="#" className="hover:text-yubico-green-400 transition-colors">Security Overview</a>
              <a href="#" className="hover:text-yubico-green-400 transition-colors">Support</a>
            </div>
          </div>
        </div>
      </footer>
    )
  }

  return (
    <footer className="border-t border-gray-200 bg-gray-50 py-8">
      <div className="max-w-7xl mx-auto px-6 text-center">
        <p className="text-sm text-gray-500">
          &copy; {new Date().getFullYear()} Acme Corp. Secured by Yubico&reg; YubiKey&reg;. All rights reserved.
        </p>
      </div>
    </footer>
  )
}

export default Footer
